import { render, staticRenderFns } from "./ServiceProjects.vue?vue&type=template&id=6e95043b&scoped=true&"
import script from "./ServiceProjects.vue?vue&type=script&lang=js&"
export * from "./ServiceProjects.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProjects.vue?vue&type=style&index=0&id=6e95043b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95043b",
  null
  
)

export default component.exports